import { useMemo } from 'react';
import { Image, Markdown, Link } from '../../snippets';

export function SizeGuide({
  productType,
  sizeGuides,
}) {
  const sizeGuide = useMemo(() => sizeGuides?.sizeGuide ?? [], [sizeGuides]);
  console.log('sizeGuide', sizeGuide);

  return (
    <div>
      <h2 className="text-title-h3 text-center">Size Guide</h2>
      <h6 className="text-title-h6 text-center mb-6">{productType}</h6>
      {sizeGuide?.map((item, index) => {
        const types = item?.productTypes;
        const type = types?.some(type => type.productType === productType);

        return type === true ? (
          <>
            <table key={`size-guide-${index}`} className="w-full border-collapse">
              <thead>
                <tr>
                  {item?.columns?.map((column, index) => (
                    <th key={`column-${index}`} className="p-2 max-md:text-sm border ms:px-4 md:py-2">{column?.name}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {item?.rows?.map((row, index) => (
                  <tr key={`row-${index}`}>
                    {row?.values?.map((value, index) => (
                      <td key={`value-${index}`} className="p-2 max-md:text-sm border ms:px-4 md:py-2">{value.value}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>

            {item?.image?.src && (item?.howToMeasure && item.howToMeasure.trim() !== '') && (
              <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-5">
                {item?.image?.src && (
                  <div className="relative w-full h-0 pb-[100%] mt-5">
                    <Image
                      alt={item?.imageAltText}
                      className="absolute top-0 left-0 w-full h-full"
                      fill
                      priority
                      sizes="100vw"
                      src={item?.image?.src}
                    />
                  </div>
                )}
                
                {item?.howToMeasure && item.howToMeasure.trim() !== '' && (
                  <div>
                    <Markdown key={`description-${index}`} containerClassNames="my-5">
                      {item.howToMeasure}
                    </Markdown>

                    {item.moreInfo?.text && (
                      <Link
                        aria-label={`Open ${item.moreInfo.text}`}
                        className="text-underline"
                        href={item.moreInfo.url}
                        newTab
                      >
                        {item.moreInfo.text}
                      </Link>
                    )}
                  </div>
                )}              
              </div>
            )}
          </>
        ) : null;
      })}

    </div>
  );
}

SizeGuide.displayName = 'SizeGuide';